
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/puppies-for-sale/[breed-slug]/[state]/[city]",
      function () {
        return require("private-next-pages/puppies-for-sale/[breed-slug]/[state]/[city].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/puppies-for-sale/[breed-slug]/[state]/[city]"])
      });
    }
  